import "./President.css";
import PresidentImg from "../../assets/president.png";
import secretaryImg from "../../assets/secretary.png";
import StartingQuote from "../../assets/left-quote.svg";
import EndingQuote from "../../assets/right-quote.svg";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import { Card } from "@mui/material";

function President() {
  return (
    <div className="president" id="president">
      {/* <Container>
        <div className="section-title">
          About
          <br />
          President
        </div>
        <Row>
          <Col lg={6}>
            <img
              src={PresidentImg}
              alt="president"
              className="president-img img-fluid"
            />
          </Col>

          <Col lg={5}>
            <div className="pt-5 pt-lg-0">
              <div className="president-name">Dr. C.A. Thambi</div>
              <div>
                <img
                  src={StartingQuote}
                  alt="Starting Quote"
                  className="py-4"
                />
                <div className="president-msg text-justify">
                  Dear Friends, Alumni, and Well-wishers, It is an honor and
                  privilege to address you as the President of the 16th MBBS
                  Batch of Calicut Medical College. Our journey together has
                  been nothing short of extraordinary, filled with countless
                  memories, challenges, and triumphs that have shaped us into
                  the professionals we are today. From the very first day on
                  campus, we were more than just students—we were a family.
                  United by our shared aspirations and unwavering determination,
                  we supported one another through the rigors of medical
                  education while embracing the joy of friendship and
                  camaraderie. Beyond academics, we took part in cultural
                  festivities, sports, medical camps, and community service,
                  leaving an indelible mark on our institution and the people
                  around us. This website stands as a tribute to our collective
                  spirit and the remarkable journey we embarked upon together.
                  It is a space to reconnect, reminisce, and celebrate the
                  legacy of the 16th MBBS Batch—a legacy built on passion,
                  perseverance, and lifelong bonds. As we continue our paths in
                  different directions, let us always hold close the lessons we
                  learned and the friendships we forged. Our batch will forever
                  be a symbol of excellence, unity, and resilience. With warm
                  regards,
                </div>
                <img src={EndingQuote} alt="Ending Quote" className="py-4" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      <Container>
        <div className="section-title  about-secretary ">
          About
          <br />
          secretary
        </div>
        <Row>
          <Col lg={5}>
            <div className="pt-0">
              <div className="secretary-name">Dr. Jaya Prakash </div>
              <div>
                <br />
                <img
                  src={StartingQuote}
                  alt="Starting Quote"
                  className=""
                />
                <div className="secretary-msg text-justify">
                  Warmest congratulations to the entire team on the triumphant
                  launch of our official website! This momentous occasion marks
                  a significant milestone in our journey, representing a
                  substantial step forward in connecting, communicating, and
                  celebrating the outstanding achievements of our exceptionally
                  talented group of medical professionals. May this platform
                  serve as a vibrant and dynamic hub where knowledge,
                  experiences, and innovative ideas are shared freely and
                  openly, fostering a strong sense of community, camaraderie,
                  and collaboration among members. As we embark on this exciting
                  new chapter, I wish everyone involved all the best. May our
                  website become a beacon of collaboration, growth, and
                  excellence in the medical community, providing a valuable
                  resource for our members and beyond. I envision this platform
                  evolving into a premier destination for sharing insights, best
                  practices, and groundbreaking research, ultimately
                  contributing to the advancement of medical science and patient
                  care. May this website facilitate meaningful interactions,
                  spark new ideas, and nurture lasting relationships among our
                  members. May it also serve as a powerful tool for showcasing
                  our collective expertise, promoting our achievements, and
                  inspiring future generations of medical professionals. Here's
                  to a bright future filled with discovery, connection, and
                  progress! I'm confident that our website will play a pivotal
                  role in shaping the future of our community and making a
                  lasting impact in the world of medicine. Sincerely, JP
                </div>
                <img src={EndingQuote} alt="Ending Quote" className="py-4" />
              </div>
            </div>
          </Col>

          <Col lg={7} className="sec-img">
          <div className="secrt-img">
            <img
              src={secretaryImg}
              alt="secretart"
              className="secretary-img img-fluid"
            />
            </div>
          </Col>
        </Row>
      </Container> */}
      <Container>
        <div className="leadership-section">
          <div className="section-title center-title">Leadership</div>
          <Row className="justify-content-center">
            <Col lg={4} sm={2} md={2}>
              <div className="Cards">
                <div>
                  <img
                    src={PresidentImg}
                    alt="president"
                    className="leader-img img-fluid"
                  />
                </div>
                <div className="president-name"> <strong>Dr. C.A. Thambi</strong></div>
                <div>President</div>
                <div>
                  Honored to lead the 16th MBBS Batch of Calicut Medical
                  College, I reflect on a journey filled with learning,
                  friendship, and meaning. This website celebrates our unity,
                  memories, excellence, passion, and lifelong connection.
                </div>
                <img src={EndingQuote} alt="Ending Quote" className="py-4" />
              </div>
            </Col>
            <Col lg={4} sm={2} md={2}>
              <div className="Cards">
                <div>
                  <img
                    src={secretaryImg}
                    alt="secretart"
                    className="leader-img img-fluid"
                  />
                </div>
                <div className="seceratry-name"> <strong>Dr. Jaya Prakash</strong></div>
                <div>secretary</div>
                <div className="">
                  A proud milestone—celebrating our successes and fostering a
                  spirit of collaboration, innovation, and growth.
                  May this platform continue to inspire excellence and
                  strengthen the values of our shared journey.
                </div>
                <img src={EndingQuote} alt="Ending Quote" className="py-4" />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default President;
